import { call, put } from 'redux-saga/effects';
import { ACTIONS, APIS } from '../../_config';
import { CallApi } from '../api/callApi';




export function* GetWorkRequestList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.WORK_REQUEST.GET_WORK_REQUEST_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
       
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetStatusList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.WORK_REQUEST.GET_STATUS_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
       
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* GetPriorityList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.WORK_REQUEST.GET_PRIORITY_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
       
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* GetCode(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.WORK_REQUEST.GET_CODE, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
       
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* MoveStatus(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.WORK_REQUEST.MOVE_STATUS, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
       
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* SaveWorkRequest(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.WORK_REQUEST.SAVE_WORK_REQUEST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data ) {
       
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.data.statusMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* UploadImage(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.WORK_REQUEST.UPLOAD_IMAGE, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* UploadAttachment(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.WORK_REQUEST.UPLOAD_ATTACHMENT, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetWorkRequestByID(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.WORK_REQUEST.GET_WORK_REQUEST_BY_ID, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* GetWorkRequestAttachments(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.WORK_REQUEST.GET_ATTACHMENT, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* GetWorkRequestImages(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.WORK_REQUEST.GET_IMAGES, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* DeleteWorkRequestFiles(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.DELETE, APIS.WORK_REQUEST.DELETE_WORK_REQUEST_FILES + "?WorkRequestFileID=" + data.WorkRequestFileID, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* SaveWorkRequestNotes(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.WORK_REQUEST.SAVE_WORK_REQUEST_NOTES, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* DeleteWorkRequestNotes(action: any): any {
    try {
        const data  = action.payload;
        const resp = yield call(CallApi.POST, APIS.WORK_REQUEST.DELETE_WORK_REQUEST_NOTES, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetWorkRequestNotesList(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.WORK_REQUEST.GET_WORK_REQUEST_NOTES_LIST, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}


export function* ExportToPDF(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.WORK_REQUEST.EXPORT_PDF, data, true,true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}



export function* ExportToXLS(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.GET, APIS.WORK_REQUEST.EXPORT_XLS, data, true,true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}



export function* DeleteWorkRequest(action: any): any {
    try {
        const data :any  = action.payload;
        const resp = yield call(CallApi.DELETE, APIS.WORK_REQUEST.DELETE_WORK_REQUEST + '?WorkRequestID='+data?.WorkRequestID, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* GetListForKanbanView(action: any): any {
    try {
        const data :any  = action.payload;
        const resp = yield call(CallApi.GET, APIS.WORK_REQUEST.GET_LIST_FOR_KANBAN_VIEW, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ProcessAudio(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.WORK_REQUEST.WORK_REQUEST_PROCESS_AUDIO, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export function* ProcessFeedback(action: any): any {
    try {
        const data = action.payload;
        const resp = yield call(CallApi.POST, APIS.WORK_REQUEST.WORK_REQUEST_PROCESS_FEEDBACK, data, true);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.message);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}













 

 



